module.exports = __webpack_public_path__ + "static/media/MinionPro-Disp.e376da71.woff";